import { makeStyles } from 'tss-react/mui';
import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';
import {
  BLACK_ICON,
  DATA_MANAGEMENT_BLUE,
  ERROR_ICON,
  SECONDARY_BLUE_2,
  TRANSPARENT_BLACK_10,
  TRANSPARENT_BLACK_26,
  TRANSPARENT_BLACK_50,
  TRANSPARENT_BLACK_80,
  WHITE,
} from 'utilities/colors';

export const useAiComputeTransactionsCardStyles = makeStyles()(() => ({
  sourceLink: {
    fontSize: '1.125rem',
    display: 'flex',
    color: DATA_MANAGEMENT_BLUE,
    alignItems: 'center',
  },
  sourceLinkIcon: {
    height: '1.25rem',
    marginRight: '0.25rem',
  },
  redText: {
    color: ERROR_ICON,
  },
  blueText: {
    color: `${DATA_MANAGEMENT_BLUE} !important`,
  },
  icon: {
    marginRight: '0.5rem',
  },
  statusContainer: {
    display: 'flex',
  },
  serviceLogo: {
    height: '1.5rem',
    width: '1.5rem',
    objectFit: 'contain',
  },
  tabs: {
    height: '60px',
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    marginLeft: '0.25rem',
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
    textDecoration: 'underline',
    color: DATA_MANAGEMENT_BLUE,
  },
  label: {
    fontWeight: 500,
    color: TRANSPARENT_BLACK_50,
    fontSize: '0.75rem',
  },
  tableHeader: {
    borderBottom: `1px solid ${TRANSPARENT_BLACK_10}`,
    paddingRight: '1.75rem',
    paddingBlock: '0.75rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tableBody: {
    overflowY: 'scroll',
    height: '44vh',
    ...VERTICAL_SCROLL_STYLE,
  },
  row: {
    padding: '1rem 1.75rem',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_10}`,
    '&:hover': { backgroundColor: '#f3f3f3' }, // ← added hover colour
  },
  columnLabel: {
    color: TRANSPARENT_BLACK_50,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1em',
  },
  defaultLabel: {
    fontSize: '1.125rem',
    color: TRANSPARENT_BLACK_80,
  },
  boldLabel: {
    fontSize: '1.125rem',
    color: TRANSPARENT_BLACK_80,
    fontWeight: 500,
  },
}));

export const useSearchStyles = makeStyles()(() => ({
  searchField: {
    width: '100%',
    padding: '0.5rem 0.5rem 0.5rem 2.5rem',
    borderRadius: '4px',
    border: `1px solid ${TRANSPARENT_BLACK_26}`,
    boxSizing: 'border-box',
  },
  container: {
    width: '40%',
    position: 'relative',
  },
  icon: {
    color: TRANSPARENT_BLACK_50,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '0.5rem',
  },
}));

export const useModelFilterDropdownStyles = makeStyles()(() => ({
  firstItem: {
    borderBottom: '1px solid red',
  },
  noFilterIcon: {
    marginBottom: '0.125rem',
  },
  verticalCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  noFilterLogo: {
    width: '1.875rem',
  },
  selectRoot: {
    width: '16rem ',
  },
  serviceLogo: {
    height: '1.375rem',
    width: '1.25rem',
    objectFit: 'contain',
  },
  menuItemRoot: {
    height: '2.5rem',
  },
  menuItemSelected: {
    height: '2.5rem',
    backgroundColor: `${DATA_MANAGEMENT_BLUE} !important`,
    color: 'white',
  },
}));

export const useNoDataPlaceholderStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    [theme.breakpoints.down('laptop')]: {
      gap: 16,
    },
  },
  icon: {
    height: 'auto',
    color: BLACK_ICON,
    opacity: 0.5,
    [theme.breakpoints.down('laptop')]: {
      width: 80,
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontWeight: 500,
    fontSize: '1.25rem',
    color: '#484848',
    [theme.breakpoints.down('laptop')]: {
      fontSize: '1.125rem',
    },
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '0.875rem',
    color: '#484848',
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    color: WHITE,
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: '6px 16px',
    borderRadius: 4,
    backgroundColor: SECONDARY_BLUE_2,
    '& icon': {
      width: 20,
    },
    '&:hover': {
      backgroundColor: SECONDARY_BLUE_2,
    },
  },
}));
